// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-formation__content .show-post-formation-field__field-img {
    width: 360px;
}

.show-post-formation-field__field-img {
    text-align: center;
}

.show-post-formation-field__row {
    display: flex;
    justify-content: space-evenly;
}

.show-post-formation-field__row__assigned__container .icon-ball {

    font-size: 50px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    color: var(--white-color);
}

.show-post-field__positions {
    position: relative;
}

.show-post-formation-field__container__img {
    text-align: center;
}

.show-post-formation-field {
    width: 360px;
    position: absolute;
    height: 530px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.show-post-formation-field__username.baloa-truncate {
    width: calc( var( --space-x3 ) + var( --space-quarter ) );
    text-align: center;
}

.show-post-formation-field__username.baloa-username {
    color: var( --primary-dark-color );
}

.show-post-formation-field__username__container {
    background: var( --white-color );
    border-radius: calc( var( --space-half ) + 1px );
    display: flex;
    align-items: center;
    padding: 2px 4px;
    margin-top: var( --space-half );
}

.show-post-field__container {
    display: flex;
    justify-content: center;
}

.show-post-formation-field__row__assigned {
    display: flex;
    flex-direction: column;
    align-items: center;
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
    
    /* .show-post-formation-field__row__striker {
        margin-bottom: 32%;
    }
    .show-post-formation-field__row__midfielder {
        margin-bottom: 27%;
    }
    .show-post-formation-field__row__defender {
        margin-bottom: 7%;
    } */
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    
    /* .show-post-formation-field__row__striker {
        margin-bottom: 32%;
    }
    .show-post-formation-field__row__midfielder {
        margin-bottom: 27%;
    }
    .show-post-formation-field__row__defender {
        margin-bottom: 7%;
    } */
}

@media only screen and (min-width: 1201px) and (max-width: 1439px) {
    
    /* .show-post-formation-field__row__striker {
        margin-bottom: 17%;
    }
    .show-post-formation-field__row__midfielder {
        margin-bottom: 12%;
    }
    .show-post-formation-field__row__defender {
        margin-bottom: 3%;
    }     */
}

@media only screen and (min-width: 1440px) and (max-width: 1600px) {
    
    /* .show-post-formation-field__row__striker {
        margin-bottom: 25%;
    }
    .show-post-formation-field__row__midfielder {
        margin-bottom: 20%;
    }
    .show-post-formation-field__row__defender {
        margin-bottom: 7%;
    }             */
}

@media only screen and (min-width: 1601px) {
    
    /* .show-post-formation-field__row__striker {
        margin-bottom: 33%;
    }
    .show-post-formation-field__row__midfielder {
        margin-bottom: 26%;
    }
    .show-post-formation-field__row__defender {
        margin-bottom: 6%;
    }     */
}`, "",{"version":3,"sources":["webpack://./src/shared/components/show-post-formation/ShowPostFormationFieldComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;;IAEI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI;;;;;;;;OAQG;AACP;;AAEA;;IAEI;;;;;;;;OAQG;AACP;;AAEA;;IAEI;;;;;;;;WAQO;AACX;;AAEA;;IAEI;;;;;;;;mBAQe;AACnB;;AAEA;;IAEI;;;;;;;;WAQO;AACX","sourcesContent":[".post-formation__content .show-post-formation-field__field-img {\n    width: 360px;\n}\n\n.show-post-formation-field__field-img {\n    text-align: center;\n}\n\n.show-post-formation-field__row {\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.show-post-formation-field__row__assigned__container .icon-ball {\n\n    font-size: 50px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    color: var(--white-color);\n}\n\n.show-post-field__positions {\n    position: relative;\n}\n\n.show-post-formation-field__container__img {\n    text-align: center;\n}\n\n.show-post-formation-field {\n    width: 360px;\n    position: absolute;\n    height: 530px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n}\n\n.show-post-formation-field__username.baloa-truncate {\n    width: calc( var( --space-x3 ) + var( --space-quarter ) );\n    text-align: center;\n}\n\n.show-post-formation-field__username.baloa-username {\n    color: var( --primary-dark-color );\n}\n\n.show-post-formation-field__username__container {\n    background: var( --white-color );\n    border-radius: calc( var( --space-half ) + 1px );\n    display: flex;\n    align-items: center;\n    padding: 2px 4px;\n    margin-top: var( --space-half );\n}\n\n.show-post-field__container {\n    display: flex;\n    justify-content: center;\n}\n\n.show-post-formation-field__row__assigned {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n    \n    /* .show-post-formation-field__row__striker {\n        margin-bottom: 32%;\n    }\n    .show-post-formation-field__row__midfielder {\n        margin-bottom: 27%;\n    }\n    .show-post-formation-field__row__defender {\n        margin-bottom: 7%;\n    } */\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1200px) {\n    \n    /* .show-post-formation-field__row__striker {\n        margin-bottom: 32%;\n    }\n    .show-post-formation-field__row__midfielder {\n        margin-bottom: 27%;\n    }\n    .show-post-formation-field__row__defender {\n        margin-bottom: 7%;\n    } */\n}\n\n@media only screen and (min-width: 1201px) and (max-width: 1439px) {\n    \n    /* .show-post-formation-field__row__striker {\n        margin-bottom: 17%;\n    }\n    .show-post-formation-field__row__midfielder {\n        margin-bottom: 12%;\n    }\n    .show-post-formation-field__row__defender {\n        margin-bottom: 3%;\n    }     */\n}\n\n@media only screen and (min-width: 1440px) and (max-width: 1600px) {\n    \n    /* .show-post-formation-field__row__striker {\n        margin-bottom: 25%;\n    }\n    .show-post-formation-field__row__midfielder {\n        margin-bottom: 20%;\n    }\n    .show-post-formation-field__row__defender {\n        margin-bottom: 7%;\n    }             */\n}\n\n@media only screen and (min-width: 1601px) {\n    \n    /* .show-post-formation-field__row__striker {\n        margin-bottom: 33%;\n    }\n    .show-post-formation-field__row__midfielder {\n        margin-bottom: 26%;\n    }\n    .show-post-formation-field__row__defender {\n        margin-bottom: 6%;\n    }     */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
